import { AfterViewInit, Component, OnInit, Input } from "@angular/core";
import { MessageService } from "./message.service";
import { Message } from "./message.model";
import { Observable } from "rxjs/Observable";
import { ActivatedRoute, Router } from "@angular/router";
import { ChatSuggestionListsService } from "../../common/suggestion-lists/services/chat-suggestion-lists.service";
import { ReviewSuggestionListsService } from "../../common/suggestion-lists/services/review-suggestion-lists.service";

@Component({
  selector: "app-chat",
  templateUrl: "./chat.component.html",
  styleUrls: ["./chat.component.css"]
})
export class ChatComponent implements OnInit {
  @Input() inWork = true;
  @Input() chat = false;
  isLoaded = false;
  chatName: string;
  chatMessages: Message[] = [];
  // отправляемое сообщение
  msg = "";
  errorMessage = false;
  chatVisible = true;
  chatUsingExperience = "";

  constructor(
    public messageService: MessageService,
    public chatSuggestionListsService: ChatSuggestionListsService,
    public reviewSuggestionListsService: ReviewSuggestionListsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.isLoaded = false;
    if (this.router.url.includes("suggestion-list-details") || this.router.url.includes("ex-suggestion-expired")) {
      this.chatUsingExperience = "SL"; // Suggestions Lists
      this.chatSuggestionListsService.clearMessages();
      this.chatSuggestionListsService.getMessages().subscribe(
        (res: any) => {
          this.errorMessage = false;
          if (res.status === 200) {
            this.chatMessages = res.body.messages;
            if(this.chatMessages.length > 0){
              this.chatVisible = false;
            } else {
              this.chatVisible = true;
            }
            this.chatMessages.reverse();
            this.chatSuggestionListsService.setMessages(this.chatMessages);
          }
        },
        () => {
          this.isLoaded = true;
          this.errorMessage = true;
        }
      );
      this.chatMessages = this.chatSuggestionListsService.getTempMsg();
      this.isLoaded = true;
    } else {
      this.chatUsingExperience = "STND"; // Standards
      this.chatMessages = this.messageService.getMessages();
      // чтение нотификаций
      this.messageService.readMessages();
      this.chatName = this.messageService.chatName;
      this.isLoaded = true;
    }
  }

  changeVisibleChat() {
    this.chatVisible = this.chatVisible ? false : true;
  }

  doShowInputBlock() {
    if (this.chatUsingExperience === "STND") {
      return this.messageService.doShowInputBlock();
    } else if (this.chatUsingExperience === "SL") {
      return (
        this.reviewSuggestionListsService.getIsCurrentUserHead() ||
        this.reviewSuggestionListsService.getIsCurrentUserInitiator() ||
        this.reviewSuggestionListsService.getIsCurrentUserMember()
      );
    }
  }

  sendMessage() {
    if (this.msg.trim().length > 0) {
      switch (this.chatUsingExperience) {
        case "STND":
          this.messageService.addMessage(this.msg);
          this.msg = "";
          break;
        case "SL":
          this.chatSuggestionListsService.addMessage(this.msg);
          this.msg = "";
          break;
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/operating-standard/chat/chat.component.ts